import Svg, { Use, SvgProps, Defs, Path, G } from "react-native-svg"
import { useTheme } from "styled-rn"

export const LoginStartSignup = (props: SvgProps) => {
  const theme = useTheme()

  return (
    <Svg viewBox="0 0 355 365" {...props}>
      <Defs>
        <G id="LoginStartSignup-Layer23_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M239.75 120.85Q214.05 99.2 177.7 100.15 140.85 99.35 114.95 120.95 102.95 132 97.3 145.25 91.85 158 91.35 175.05 90.55 206.8 112.8 228.4 113.55 229.1 114.3 229.8 140.8 251.45 179.05 251.45 214 251.55 238.5 229.65 239.8 228.45 241.05 227.25 263.6 204.9 264.15 174.8 264.45 142.45 239.75 120.85M205.9 139.25Q208.35 141.7 208.6 145.4 208.8 149.1 206.65 151.8 204.5 154.6 201.2 154.75 197.95 154.95 195.5 152.45 193.1 150.05 192.85 146.3 192.65 142.65 194.8 139.9 196.95 137.2 200.25 137 203.45 136.85 205.9 139.25M213.25 176.2Q211.9 190.95 202.95 197.9 194.1 204.95 181.15 206.3 168.25 207.7 156.3 200.6 144.45 193.6 142.05 179.05 160.6 175.25 180.9 174.8 201.15 174.4 213.25 176.2M143.8 141.75Q145.95 139.05 149.25 138.85 152.45 138.7 154.9 141.1 157.35 143.55 157.6 147.25 157.8 150.95 155.65 153.65 153.5 156.45 150.2 156.6 146.95 156.8 144.5 154.3 142.1 151.9 141.85 148.15 141.65 144.5 143.8 141.75Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M149.25 138.85Q145.95 139.05 143.8 141.75 141.65 144.5 141.85 148.15 142.1 151.9 144.5 154.3 146.95 156.8 150.2 156.6 153.5 156.45 155.65 153.65 157.8 150.95 157.6 147.25 157.35 143.55 154.9 141.1 152.45 138.7 149.25 138.85M202.95 197.9Q211.9 190.95 213.25 176.2 201.15 174.4 180.9 174.8 160.6 175.25 142.05 179.05 144.45 193.6 156.3 200.6 168.25 207.7 181.15 206.3 194.1 204.95 202.95 197.9M208.6 145.4Q208.35 141.7 205.9 139.25 203.45 136.85 200.25 137 196.95 137.2 194.8 139.9 192.65 142.65 192.85 146.3 193.1 150.05 195.5 152.45 197.95 154.95 201.2 154.75 204.5 154.6 206.65 151.8 208.8 149.1 208.6 145.4Z"
          />
        </G>
        <G id="LoginStartSignup-Layer22_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M237.45 117.75Q210.8 97.25 174.55 99.75 137.7 100.55 112.75 123.25 101.25 134.8 96.2 148.3 91.3 161.25 91.55 178.3 92.05 208.4 112.95 228.55 114.1 229.7 115.35 230.8 116.05 231.4 116.8 232.05 144.25 252.55 182.45 250.9 217.35 249.5 240.9 226.5 242.8 224.6 244.55 222.65 243.65 222.1 242.7 221.6 243.65 222.1 244.55 222.65 264.9 199.85 264.15 170.6 263.65 156.25 258.35 144.35 257.6 142.6 256.7 140.9 250.05 127.9 237.45 117.75M205.3 141.55Q205.8 145.25 203.9 148.1 202.05 151.1 198.8 151.5 195.6 152 192.9 149.7 190.3 147.55 189.7 143.85 189.2 140.2 191.1 137.3 193 134.4 196.25 133.9 199.45 133.5 202.1 135.65 204.8 137.85 205.3 141.55M212.85 171.8Q212.8 186.6 204.55 194.35 196.25 202.1 183.55 204.6 170.75 207.05 158.3 201.05 145.85 195.1 142.15 180.8 160.3 175.4 180.5 173.25 200.65 171.1 212.85 171.8M145.6 140.15Q148.8 139.75 151.45 141.9 154.15 144.1 154.65 147.8 155.15 151.5 153.25 154.35 151.4 157.35 148.15 157.75 144.95 158.25 142.25 155.95 139.65 153.8 139.05 150.1 138.55 146.45 140.45 143.55 142.35 140.65 145.6 140.15Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M151.45 141.9Q148.8 139.75 145.6 140.15 142.35 140.65 140.45 143.55 138.55 146.45 139.05 150.1 139.65 153.8 142.25 155.95 144.95 158.25 148.15 157.75 151.4 157.35 153.25 154.35 155.15 151.5 154.65 147.8 154.15 144.1 151.45 141.9M204.55 194.35Q212.8 186.6 212.85 171.8 200.65 171.1 180.5 173.25 160.3 175.4 142.15 180.8 145.85 195.1 158.3 201.05 170.75 207.05 183.55 204.6 196.25 202.1 204.55 194.35M203.9 148.1Q205.8 145.25 205.3 141.55 204.8 137.85 202.1 135.65 199.45 133.5 196.25 133.9 193 134.4 191.1 137.3 189.2 140.2 189.7 143.85 190.3 147.55 192.9 149.7 195.6 152 198.8 151.5 202.05 151.1 203.9 148.1Z"
          />
        </G>
        <G id="LoginStartSignup-Layer21_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M255.25 133.3Q252.95 129.3 250.15 125.7 241.2 114.25 226.9 106.65 197 91.45 161.75 100.6 125.7 108.3 105.4 135.25 96.25 148.65 93.8 162.9 91.4 176.5 94.85 193.3 99.2 214.35 112.9 228.5 119.4 235.25 128.05 240.4 128.9 240.85 129.65 241.35 160.45 256.35 197.7 247.6 231.7 239.75 250.55 212.85 264.05 192.9 264.7 171.6 261.15 172.1 256.95 172.45 261.15 172.1 264.7 171.6 264.95 162.7 263 153.6 260.45 142.4 255.25 133.3M182.95 139.5Q179.65 138.7 177.5 135.7 175.4 132.7 175.8 129.25 176.15 125.8 178.9 123.95 181.5 122.05 184.95 122.85 188.3 123.65 190.4 126.7 192.5 129.7 192.05 133.15 191.75 136.6 189.05 138.5 186.4 140.4 182.95 139.5M210.85 150.35Q217.45 165.55 212.65 177.25 207.8 189 196.15 197.35 184.4 205.75 169.1 205.25 153.9 204.85 143.75 191.9 159.6 178.05 178.9 166.65 198.2 155.2 210.85 150.35M144.85 164.8Q142.15 166.65 138.75 165.85 135.45 165.05 133.3 161.95 131.15 158.95 131.6 155.55 132 152.05 134.7 150.15 137.35 148.4 140.75 149.15 144.15 149.95 146.25 152.95 148.3 156.05 147.9 159.45 147.55 162.95 144.85 164.8Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M138.75 165.85Q142.15 166.65 144.85 164.8 147.55 162.95 147.9 159.45 148.3 156.05 146.25 152.95 144.15 149.95 140.75 149.15 137.35 148.4 134.7 150.15 132 152.05 131.6 155.55 131.15 158.95 133.3 161.95 135.45 165.05 138.75 165.85M212.65 177.25Q217.45 165.55 210.85 150.35 198.2 155.2 178.9 166.65 159.6 178.05 143.75 191.9 153.9 204.85 169.1 205.25 184.4 205.75 196.15 197.35 207.8 189 212.65 177.25M177.5 135.7Q179.65 138.7 182.95 139.5 186.4 140.4 189.05 138.5 191.75 136.6 192.05 133.15 192.5 129.7 190.4 126.7 188.3 123.65 184.95 122.85 181.5 122.05 178.9 123.95 176.15 125.8 175.8 129.25 175.4 132.7 177.5 135.7Z"
          />
        </G>
        <G id="LoginStartSignup-Layer20_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M253.95 130.65Q251.9 126.95 249.55 123.65 245.9 118.55 241.4 114.35 230.8 104.35 215.55 98.95 183.6 88.55 150.2 102.95 115.75 116 99.8 145.7 92.8 160.45 92.5 174.8 92.2 188.65 98.15 204.75 103.35 218.7 112.5 228.7 122.8 240 138.1 246.25 139 246.55 139.85 246.95 172.55 257.05 208 242.8 240.45 229.8 255.05 200.4 269.65 169.6 258.3 139.95 256.35 135.05 253.95 130.65 252.2 131.5 250.25 132.3 252.2 131.5 253.95 130.65M163.25 127.3Q163.1 123.8 165.45 121.55 167.8 119.25 171.25 119.45 174.65 119.7 177.3 122.35 179.85 125 180 128.4 180.25 131.9 177.85 134.2 175.6 136.5 172.1 136.25 168.65 136 166.05 133.4 163.45 130.75 163.25 127.3M176.05 160.8Q194.35 144.1 206.95 136 217.6 150.6 215 164.3 212.5 177.9 201.7 189.6 190.9 201.3 174.2 204.4 157.6 207.45 143.6 196 157.65 177.55 176.05 160.8M140.15 156.8Q142.7 159.45 142.85 162.9 143.1 166.4 140.7 168.7 138.45 171 134.95 170.75 131.5 170.5 128.9 167.8 126.35 165.25 126.15 161.75 126 158.25 128.3 156 130.65 153.75 134.1 153.95 137.55 154.15 140.15 156.8Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M142.85 162.9Q142.7 159.45 140.15 156.8 137.55 154.15 134.1 153.95 130.65 153.75 128.3 156 126 158.25 126.15 161.75 126.35 165.25 128.9 167.8 131.5 170.5 134.95 170.75 138.45 171 140.7 168.7 143.1 166.4 142.85 162.9M206.95 136Q194.35 144.1 176.05 160.8 157.65 177.55 143.6 196 157.6 207.45 174.2 204.4 190.9 201.3 201.7 189.6 212.5 177.9 215 164.3 217.6 150.6 206.95 136M165.45 121.55Q163.1 123.8 163.25 127.3 163.45 130.75 166.05 133.4 168.65 136 172.1 136.25 175.6 136.5 177.85 134.2 180.25 131.9 180 128.4 179.85 125 177.3 122.35 174.65 119.7 171.25 119.45 167.8 119.25 165.45 121.55Z"
          />
        </G>
        <G id="LoginStartSignup-Layer19_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M256.95 136.85Q252.55 126.75 246 119 242.8 115.15 239.05 111.9 228.1 102.3 212.65 97.55 180.35 88.4 147.55 104.1 113.65 118.5 98.8 148.8 92.4 163.75 92.65 178.15 92.9 192.05 99.45 207.8 111.75 237.15 141 247.75 141.95 248.05 142.85 248.35 175.85 257.2 210.75 241.55 242.65 227.35 256.05 197.35 269.45 166 256.95 136.85M175.4 121.45Q178.05 124.05 178.25 127.45 178.55 130.95 176.25 133.35 174 135.7 170.45 135.5 167.05 135.3 164.4 132.7 161.75 130.15 161.5 126.7 161.25 123.2 163.55 120.9 165.85 118.6 169.3 118.7 172.75 118.85 175.4 121.45M175.45 160.2Q193.8 142.8 206.5 134.2 217.65 148.95 215.3 162.9 213 176.85 202.3 189.05 191.5 201.25 174.55 204.75 157.65 208.25 143.15 196.9 157.1 177.75 175.45 160.2M139 157.2Q141.65 159.8 141.9 163.25 142.2 166.75 139.85 169.05 137.6 171.45 134.1 171.2 130.7 171.1 128 168.5 125.4 165.95 125.1 162.45 124.85 159 127.15 156.65 129.45 154.35 132.9 154.5 136.4 154.6 139 157.2Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M141.9 163.25Q141.65 159.8 139 157.2 136.4 154.6 132.9 154.5 129.45 154.35 127.15 156.65 124.85 159 125.1 162.45 125.4 165.95 128 168.5 130.7 171.1 134.1 171.2 137.6 171.45 139.85 169.05 142.2 166.75 141.9 163.25M206.5 134.2Q193.8 142.8 175.45 160.2 157.1 177.75 143.15 196.9 157.65 208.25 174.55 204.75 191.5 201.25 202.3 189.05 213 176.85 215.3 162.9 217.65 148.95 206.5 134.2M178.25 127.45Q178.05 124.05 175.4 121.45 172.75 118.85 169.3 118.7 165.85 118.6 163.55 120.9 161.25 123.2 161.5 126.7 161.75 130.15 164.4 132.7 167.05 135.3 170.45 135.5 174 135.7 176.25 133.35 178.55 130.95 178.25 127.45Z"
          />
        </G>
        <G id="LoginStartSignup-Layer18_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M256.95 136.9Q252 125.55 244.35 117.15 241.85 114.4 239.05 111.95 228.1 102.35 212.65 97.6 180.35 88.45 147.55 104.15 113.65 118.55 98.8 148.85 92.4 163.8 92.65 178.2 92.9 192.1 99.45 207.85 111.75 237.2 141 247.8 141.95 248.1 142.85 248.4 175.85 257.25 210.75 241.6 242.65 227.4 256.05 197.4 269.45 166.05 256.95 136.9M175.4 121.5Q178.05 124.1 178.25 127.5 178.55 131 176.25 133.4 174 135.75 170.45 135.55 167.05 135.35 164.4 132.75 161.75 130.2 161.5 126.75 161.25 123.25 163.55 120.95 165.85 118.65 169.3 118.75 172.75 118.9 175.4 121.5M175.45 160.25Q193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95 157.1 177.8 175.45 160.25M139 157.25Q141.65 159.85 141.9 163.3 142.2 166.8 139.85 169.1 137.6 171.5 134.1 171.25 130.7 171.15 128 168.55 125.4 166 125.1 162.5 124.85 159.05 127.15 156.7 129.45 154.4 132.9 154.55 136.4 154.65 139 157.25Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M141.9 163.3Q141.65 159.85 139 157.25 136.4 154.65 132.9 154.55 129.45 154.4 127.15 156.7 124.85 159.05 125.1 162.5 125.4 166 128 168.55 130.7 171.15 134.1 171.25 137.6 171.5 139.85 169.1 142.2 166.8 141.9 163.3M206.5 134.25Q193.8 142.85 175.45 160.25 157.1 177.8 143.15 196.95 157.65 208.3 174.55 204.8 191.5 201.3 202.3 189.1 213 176.9 215.3 162.95 217.65 149 206.5 134.25M178.25 127.5Q178.05 124.1 175.4 121.5 172.75 118.9 169.3 118.75 165.85 118.65 163.55 120.95 161.25 123.25 161.5 126.75 161.75 130.2 164.4 132.75 167.05 135.35 170.45 135.55 174 135.75 176.25 133.4 178.55 131 178.25 127.5Z"
          />
        </G>
        <G id="LoginStartSignup-Layer17_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M242.95 115.65Q241.05 113.7 239.05 111.95 228.1 102.35 212.65 97.6 180.35 88.45 147.55 104.15 113.65 118.55 98.8 148.85 92.4 163.8 92.65 178.2 92.9 192.1 99.45 207.85 111.75 237.2 141 247.8 141.95 248.1 142.85 248.4 175.85 257.25 210.75 241.6 242.65 227.4 256.05 197.4 269.45 166.05 256.95 136.9 251.5 124.5 242.95 115.65M175.4 121.5Q178.05 124.1 178.25 127.5 178.55 131 176.25 133.4 174 135.75 170.45 135.55 167.05 135.35 164.4 132.75 161.75 130.2 161.5 126.75 161.25 123.25 163.55 120.95 165.85 118.65 169.3 118.75 172.75 118.9 175.4 121.5M175.45 160.25Q193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95 157.1 177.8 175.45 160.25M139 157.25Q141.65 159.85 141.9 163.3 142.2 166.8 139.85 169.1 137.6 171.5 134.1 171.25 130.7 171.15 128 168.55 125.4 166 125.1 162.5 124.85 159.05 127.15 156.7 129.45 154.4 132.9 154.55 136.4 154.65 139 157.25Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M141.9 163.3Q141.65 159.85 139 157.25 136.4 154.65 132.9 154.55 129.45 154.4 127.15 156.7 124.85 159.05 125.1 162.5 125.4 166 128 168.55 130.7 171.15 134.1 171.25 137.6 171.5 139.85 169.1 142.2 166.8 141.9 163.3M206.5 134.25Q193.8 142.85 175.45 160.25 157.1 177.8 143.15 196.95 157.65 208.3 174.55 204.8 191.5 201.3 202.3 189.1 213 176.9 215.3 162.95 217.65 149 206.5 134.25M178.25 127.5Q178.05 124.1 175.4 121.5 172.75 118.9 169.3 118.75 165.85 118.65 163.55 120.95 161.25 123.25 161.5 126.75 161.75 130.2 164.4 132.75 167.05 135.35 170.45 135.55 174 135.75 176.25 133.4 178.55 131 178.25 127.5Z"
          />
        </G>
        <G id="LoginStartSignup-Layer16_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M256.95 136.9Q251.75 125 243.65 116.4 241.45 114.05 239.05 111.95 228.1 102.35 212.65 97.6 180.35 88.45 147.55 104.15 113.65 118.55 98.8 148.85 92.4 163.8 92.65 178.2 92.9 192.1 99.45 207.85 111.75 237.2 141 247.8 141.95 248.1 142.85 248.4 175.85 257.25 210.75 241.6 242.65 227.4 256.05 197.4 269.45 166.05 256.95 136.9M175.4 121.5Q178.05 124.1 178.25 127.5 178.55 131 176.25 133.4 174 135.75 170.45 135.55 167.05 135.35 164.4 132.75 161.75 130.2 161.5 126.75 161.25 123.25 163.55 120.95 165.85 118.65 169.3 118.75 172.75 118.9 175.4 121.5M175.45 160.25Q193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95 157.1 177.8 175.45 160.25M139 157.25Q141.65 159.85 141.9 163.3 142.2 166.8 139.85 169.1 137.6 171.5 134.1 171.25 130.7 171.15 128 168.55 125.4 166 125.1 162.5 124.85 159.05 127.15 156.7 129.45 154.4 132.9 154.55 136.4 154.65 139 157.25Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M141.9 163.3Q141.65 159.85 139 157.25 136.4 154.65 132.9 154.55 129.45 154.4 127.15 156.7 124.85 159.05 125.1 162.5 125.4 166 128 168.55 130.7 171.15 134.1 171.25 137.6 171.5 139.85 169.1 142.2 166.8 141.9 163.3M206.5 134.25Q193.8 142.85 175.45 160.25 157.1 177.8 143.15 196.95 157.65 208.3 174.55 204.8 191.5 201.3 202.3 189.1 213 176.9 215.3 162.95 217.65 149 206.5 134.25M178.25 127.5Q178.05 124.1 175.4 121.5 172.75 118.9 169.3 118.75 165.85 118.65 163.55 120.95 161.25 123.25 161.5 126.75 161.75 130.2 164.4 132.75 167.05 135.35 170.45 135.55 174 135.75 176.25 133.4 178.55 131 178.25 127.5Z"
          />
        </G>
        <G id="LoginStartSignup-Layer15_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M256.95 136.85Q252.25 126.15 245.25 118.1 242.35 114.75 239.05 111.9 228.1 102.3 212.65 97.55 180.35 88.4 147.55 104.1 113.65 118.5 98.8 148.8 92.4 163.75 92.65 178.15 92.9 192.05 99.45 207.8 111.75 237.15 141 247.75 141.95 248.05 142.85 248.35 175.85 257.2 210.75 241.55 242.65 227.35 256.05 197.35 269.45 166 256.95 136.85M175.4 121.45Q178.05 124.05 178.25 127.45 178.55 130.95 176.25 133.35 174 135.7 170.45 135.5 167.05 135.3 164.4 132.7 161.75 130.15 161.5 126.7 161.25 123.2 163.55 120.9 165.85 118.6 169.3 118.7 172.75 118.85 175.4 121.45M175.45 160.2Q193.8 142.8 206.5 134.2 217.65 148.95 215.3 162.9 213 176.85 202.3 189.05 191.5 201.25 174.55 204.75 157.65 208.25 143.15 196.9 157.1 177.75 175.45 160.2M139 157.2Q141.65 159.8 141.9 163.25 142.2 166.75 139.85 169.05 137.6 171.45 134.1 171.2 130.7 171.1 128 168.5 125.4 165.95 125.1 162.45 124.85 159 127.15 156.65 129.45 154.35 132.9 154.5 136.4 154.6 139 157.2Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M141.9 163.25Q141.65 159.8 139 157.2 136.4 154.6 132.9 154.5 129.45 154.35 127.15 156.65 124.85 159 125.1 162.45 125.4 165.95 128 168.5 130.7 171.1 134.1 171.2 137.6 171.45 139.85 169.05 142.2 166.75 141.9 163.25M206.5 134.2Q193.8 142.8 175.45 160.2 157.1 177.75 143.15 196.9 157.65 208.25 174.55 204.75 191.5 201.25 202.3 189.05 213 176.85 215.3 162.9 217.65 148.95 206.5 134.2M178.25 127.45Q178.05 124.05 175.4 121.45 172.75 118.85 169.3 118.7 165.85 118.6 163.55 120.9 161.25 123.2 161.5 126.7 161.75 130.15 164.4 132.7 167.05 135.3 170.45 135.5 174 135.7 176.25 133.35 178.55 130.95 178.25 127.45Z"
          />
        </G>
        <G id="LoginStartSignup-Layer14_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M256.95 136.9Q253.15 128.25 247.85 121.3 243.85 116.15 239.05 111.95 228.1 102.35 212.65 97.6 180.35 88.45 147.55 104.15 113.65 118.55 98.8 148.85 92.4 163.8 92.65 178.2 92.9 192.1 99.45 207.85 111.75 237.2 141 247.8 141.95 248.1 142.85 248.4 175.85 257.25 210.75 241.6 242.65 227.4 256.05 197.4 269.45 166.05 256.95 136.9M175.4 121.5Q178.05 124.1 178.25 127.5 178.55 131 176.25 133.4 174 135.75 170.45 135.55 167.05 135.35 164.4 132.75 161.75 130.2 161.5 126.75 161.25 123.25 163.55 120.95 165.85 118.65 169.3 118.75 172.75 118.9 175.4 121.5M175.45 160.25Q193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95 157.1 177.8 175.45 160.25M139 157.25Q141.65 159.85 141.9 163.3 142.2 166.8 139.85 169.1 137.6 171.5 134.1 171.25 130.7 171.15 128 168.55 125.4 166 125.1 162.5 124.85 159.05 127.15 156.7 129.45 154.4 132.9 154.55 136.4 154.65 139 157.25Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M141.9 163.3Q141.65 159.85 139 157.25 136.4 154.65 132.9 154.55 129.45 154.4 127.15 156.7 124.85 159.05 125.1 162.5 125.4 166 128 168.55 130.7 171.15 134.1 171.25 137.6 171.5 139.85 169.1 142.2 166.8 141.9 163.3M206.5 134.25Q193.8 142.85 175.45 160.25 157.1 177.8 143.15 196.95 157.65 208.3 174.55 204.8 191.5 201.3 202.3 189.1 213 176.9 215.3 162.95 217.65 149 206.5 134.25M178.25 127.5Q178.05 124.1 175.4 121.5 172.75 118.9 169.3 118.75 165.85 118.65 163.55 120.95 161.25 123.25 161.5 126.75 161.75 130.2 164.4 132.75 167.05 135.35 170.45 135.55 174 135.75 176.25 133.4 178.55 131 178.25 127.5Z"
          />
        </G>
        <G id="LoginStartSignup-Layer13_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M256.9 136.9Q253.9 130.05 249.95 124.25 245.15 117.3 239 111.95 228.05 102.35 212.6 97.6 180.3 88.45 147.5 104.15 113.6 118.55 98.75 148.85 92.35 163.8 92.6 178.2 92.85 192.1 99.4 207.85 111.7 237.2 140.95 247.8 141.9 248.1 142.8 248.4 175.8 257.25 210.7 241.6 242.6 227.4 256 197.4 269.4 166.05 256.9 136.9M175.35 121.5Q178 124.1 178.2 127.5 178.5 131 176.2 133.4 173.95 135.75 170.4 135.55 167 135.35 164.35 132.75 161.7 130.2 161.45 126.75 161.2 123.25 163.5 120.95 165.8 118.65 169.25 118.75 172.7 118.9 175.35 121.5M175.4 160.25Q193.75 142.85 206.45 134.25 217.6 149 215.25 162.95 212.95 176.9 202.25 189.1 191.45 201.3 174.5 204.8 157.6 208.3 143.1 196.95 157.05 177.8 175.4 160.25M138.95 157.25Q141.6 159.85 141.85 163.3 142.15 166.8 139.8 169.1 137.55 171.5 134.05 171.25 130.65 171.15 127.95 168.55 125.35 166 125.05 162.5 124.8 159.05 127.1 156.7 129.4 154.4 132.85 154.55 136.35 154.65 138.95 157.25Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M141.85 163.3Q141.6 159.85 138.95 157.25 136.35 154.65 132.85 154.55 129.4 154.4 127.1 156.7 124.8 159.05 125.05 162.5 125.35 166 127.95 168.55 130.65 171.15 134.05 171.25 137.55 171.5 139.8 169.1 142.15 166.8 141.85 163.3M206.45 134.25Q193.75 142.85 175.4 160.25 157.05 177.8 143.1 196.95 157.6 208.3 174.5 204.8 191.45 201.3 202.25 189.1 212.95 176.9 215.25 162.95 217.6 149 206.45 134.25M178.2 127.5Q178 124.1 175.35 121.5 172.7 118.9 169.25 118.75 165.8 118.65 163.5 120.95 161.2 123.25 161.45 126.75 161.7 130.2 164.35 132.75 167 135.35 170.4 135.55 173.95 135.75 176.2 133.4 178.5 131 178.2 127.5Z"
          />
        </G>
        <G id="LoginStartSignup-Layer12_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M256.95 136.9Q253.35 128.65 248.35 121.95 244.15 116.4 239.05 111.95 228.1 102.35 212.65 97.6 180.35 88.45 147.55 104.15 113.65 118.55 98.8 148.85 92.4 163.8 92.65 178.2 92.9 192.1 99.45 207.85 111.75 237.2 141 247.8 141.95 248.1 142.85 248.4 175.85 257.25 210.75 241.6 242.65 227.4 256.05 197.4 269.45 166.05 256.95 136.9M175.4 121.5Q178.05 124.1 178.25 127.5 178.55 131 176.25 133.4 174 135.75 170.45 135.55 167.05 135.35 164.4 132.75 161.75 130.2 161.5 126.75 161.25 123.25 163.55 120.95 165.85 118.65 169.3 118.75 172.75 118.9 175.4 121.5M175.45 160.25Q193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95 157.1 177.8 175.45 160.25M139 157.25Q141.65 159.85 141.9 163.3 142.2 166.8 139.85 169.1 137.6 171.5 134.1 171.25 130.7 171.15 128 168.55 125.4 166 125.1 162.5 124.85 159.05 127.15 156.7 129.45 154.4 132.9 154.55 136.4 154.65 139 157.25Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M141.9 163.3Q141.65 159.85 139 157.25 136.4 154.65 132.9 154.55 129.45 154.4 127.15 156.7 124.85 159.05 125.1 162.5 125.4 166 128 168.55 130.7 171.15 134.1 171.25 137.6 171.5 139.85 169.1 142.2 166.8 141.9 163.3M206.5 134.25Q193.8 142.85 175.45 160.25 157.1 177.8 143.15 196.95 157.65 208.3 174.55 204.8 191.5 201.3 202.3 189.1 213 176.9 215.3 162.95 217.65 149 206.5 134.25M178.25 127.5Q178.05 124.1 175.4 121.5 172.75 118.9 169.3 118.75 165.85 118.65 163.55 120.95 161.25 123.25 161.5 126.75 161.75 130.2 164.4 132.75 167.05 135.35 170.45 135.55 174 135.75 176.25 133.4 178.55 131 178.25 127.5Z"
          />
        </G>
        <G id="LoginStartSignup-Layer11_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M256.95 136.9Q252 125.55 244.35 117.15 241.85 114.4 239.05 111.95 228.1 102.35 212.65 97.6 180.35 88.45 147.55 104.15 113.65 118.55 98.8 148.85 92.4 163.8 92.65 178.2 92.9 192.1 99.45 207.85 111.75 237.2 141 247.8 141.95 248.1 142.85 248.4 175.85 257.25 210.75 241.6 242.65 227.4 256.05 197.4 269.45 166.05 256.95 136.9M175.4 121.5Q178.05 124.1 178.25 127.5 178.55 131 176.25 133.4 174 135.75 170.45 135.55 167.05 135.35 164.4 132.75 161.75 130.2 161.5 126.75 161.25 123.25 163.55 120.95 165.85 118.65 169.3 118.75 172.75 118.9 175.4 121.5M175.45 160.25Q193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95 157.1 177.8 175.45 160.25M139 157.25Q141.65 159.85 141.9 163.3 142.2 166.8 139.85 169.1 137.6 171.5 134.1 171.25 130.7 171.15 128 168.55 125.4 166 125.1 162.5 124.85 159.05 127.15 156.7 129.45 154.4 132.9 154.55 136.4 154.65 139 157.25Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M141.9 163.3Q141.65 159.85 139 157.25 136.4 154.65 132.9 154.55 129.45 154.4 127.15 156.7 124.85 159.05 125.1 162.5 125.4 166 128 168.55 130.7 171.15 134.1 171.25 137.6 171.5 139.85 169.1 142.2 166.8 141.9 163.3M206.5 134.25Q193.8 142.85 175.45 160.25 157.1 177.8 143.15 196.95 157.65 208.3 174.55 204.8 191.5 201.3 202.3 189.1 213 176.9 215.3 162.95 217.65 149 206.5 134.25M178.25 127.5Q178.05 124.1 175.4 121.5 172.75 118.9 169.3 118.75 165.85 118.65 163.55 120.95 161.25 123.25 161.5 126.75 161.75 130.2 164.4 132.75 167.05 135.35 170.45 135.55 174 135.75 176.25 133.4 178.55 131 178.25 127.5Z"
          />
        </G>
        <G id="LoginStartSignup-Layer10_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M242.95 115.65Q241.05 113.7 239.05 111.95 228.1 102.35 212.65 97.6 180.35 88.45 147.55 104.15 113.65 118.55 98.8 148.85 92.4 163.8 92.65 178.2 92.9 192.1 99.45 207.85 111.75 237.2 141 247.8 141.95 248.1 142.85 248.4 175.85 257.25 210.75 241.6 242.65 227.4 256.05 197.4 269.45 166.05 256.95 136.9 251.5 124.5 242.95 115.65M175.4 121.5Q178.05 124.1 178.25 127.5 178.55 131 176.25 133.4 174 135.75 170.45 135.55 167.05 135.35 164.4 132.75 161.75 130.2 161.5 126.75 161.25 123.25 163.55 120.95 165.85 118.65 169.3 118.75 172.75 118.9 175.4 121.5M175.45 160.25Q193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95 157.1 177.8 175.45 160.25M139 157.25Q141.65 159.85 141.9 163.3 142.2 166.8 139.85 169.1 137.6 171.5 134.1 171.25 130.7 171.15 128 168.55 125.4 166 125.1 162.5 124.85 159.05 127.15 156.7 129.45 154.4 132.9 154.55 136.4 154.65 139 157.25Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M141.9 163.3Q141.65 159.85 139 157.25 136.4 154.65 132.9 154.55 129.45 154.4 127.15 156.7 124.85 159.05 125.1 162.5 125.4 166 128 168.55 130.7 171.15 134.1 171.25 137.6 171.5 139.85 169.1 142.2 166.8 141.9 163.3M206.5 134.25Q193.8 142.85 175.45 160.25 157.1 177.8 143.15 196.95 157.65 208.3 174.55 204.8 191.5 201.3 202.3 189.1 213 176.9 215.3 162.95 217.65 149 206.5 134.25M178.25 127.5Q178.05 124.1 175.4 121.5 172.75 118.9 169.3 118.75 165.85 118.65 163.55 120.95 161.25 123.25 161.5 126.75 161.75 130.2 164.4 132.75 167.05 135.35 170.45 135.55 174 135.75 176.25 133.4 178.55 131 178.25 127.5Z"
          />
        </G>
        <G id="LoginStartSignup-Layer9_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M256.95 136.9Q251.75 125 243.65 116.4 241.45 114.05 239.05 111.95 228.1 102.35 212.65 97.6 180.35 88.45 147.55 104.15 113.65 118.55 98.8 148.85 92.4 163.8 92.65 178.2 92.9 192.1 99.45 207.85 111.75 237.2 141 247.8 141.95 248.1 142.85 248.4 175.85 257.25 210.75 241.6 242.65 227.4 256.05 197.4 269.45 166.05 256.95 136.9M175.4 121.5Q178.05 124.1 178.25 127.5 178.55 131 176.25 133.4 174 135.75 170.45 135.55 167.05 135.35 164.4 132.75 161.75 130.2 161.5 126.75 161.25 123.25 163.55 120.95 165.85 118.65 169.3 118.75 172.75 118.9 175.4 121.5M175.45 160.25Q193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95 157.1 177.8 175.45 160.25M139 157.25Q141.65 159.85 141.9 163.3 142.2 166.8 139.85 169.1 137.6 171.5 134.1 171.25 130.7 171.15 128 168.55 125.4 166 125.1 162.5 124.85 159.05 127.15 156.7 129.45 154.4 132.9 154.55 136.4 154.65 139 157.25Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M141.9 163.3Q141.65 159.85 139 157.25 136.4 154.65 132.9 154.55 129.45 154.4 127.15 156.7 124.85 159.05 125.1 162.5 125.4 166 128 168.55 130.7 171.15 134.1 171.25 137.6 171.5 139.85 169.1 142.2 166.8 141.9 163.3M206.5 134.25Q193.8 142.85 175.45 160.25 157.1 177.8 143.15 196.95 157.65 208.3 174.55 204.8 191.5 201.3 202.3 189.1 213 176.9 215.3 162.95 217.65 149 206.5 134.25M178.25 127.5Q178.05 124.1 175.4 121.5 172.75 118.9 169.3 118.75 165.85 118.65 163.55 120.95 161.25 123.25 161.5 126.75 161.75 130.2 164.4 132.75 167.05 135.35 170.45 135.55 174 135.75 176.25 133.4 178.55 131 178.25 127.5Z"
          />
        </G>
        <G id="LoginStartSignup-Layer8_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M256.95 136.9Q252.25 126.2 245.25 118.15 242.35 114.8 239.05 111.95 228.1 102.35 212.65 97.6 180.35 88.45 147.55 104.15 113.65 118.55 98.8 148.85 92.4 163.8 92.65 178.2 92.9 192.1 99.45 207.85 111.75 237.2 141 247.8 141.95 248.1 142.85 248.4 175.85 257.25 210.75 241.6 242.65 227.4 256.05 197.4 269.45 166.05 256.95 136.9M175.4 121.5Q178.05 124.1 178.25 127.5 178.55 131 176.25 133.4 174 135.75 170.45 135.55 167.05 135.35 164.4 132.75 161.75 130.2 161.5 126.75 161.25 123.25 163.55 120.95 165.85 118.65 169.3 118.75 172.75 118.9 175.4 121.5M175.45 160.25Q193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95 157.1 177.8 175.45 160.25M139 157.25Q141.65 159.85 141.9 163.3 142.2 166.8 139.85 169.1 137.6 171.5 134.1 171.25 130.7 171.15 128 168.55 125.4 166 125.1 162.5 124.85 159.05 127.15 156.7 129.45 154.4 132.9 154.55 136.4 154.65 139 157.25Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M141.9 163.3Q141.65 159.85 139 157.25 136.4 154.65 132.9 154.55 129.45 154.4 127.15 156.7 124.85 159.05 125.1 162.5 125.4 166 128 168.55 130.7 171.15 134.1 171.25 137.6 171.5 139.85 169.1 142.2 166.8 141.9 163.3M206.5 134.25Q193.8 142.85 175.45 160.25 157.1 177.8 143.15 196.95 157.65 208.3 174.55 204.8 191.5 201.3 202.3 189.1 213 176.9 215.3 162.95 217.65 149 206.5 134.25M178.25 127.5Q178.05 124.1 175.4 121.5 172.75 118.9 169.3 118.75 165.85 118.65 163.55 120.95 161.25 123.25 161.5 126.75 161.75 130.2 164.4 132.75 167.05 135.35 170.45 135.55 174 135.75 176.25 133.4 178.55 131 178.25 127.5Z"
          />
        </G>
        <G id="LoginStartSignup-Layer7_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M256.95 136.95Q253.15 128.3 247.85 121.35 243.85 116.2 239.05 112 228.1 102.4 212.65 97.65 180.35 88.5 147.55 104.2 113.65 118.6 98.8 148.9 92.4 163.85 92.65 178.25 92.9 192.15 99.45 207.9 111.75 237.25 141 247.85 141.95 248.15 142.85 248.45 175.85 257.3 210.75 241.65 242.65 227.45 256.05 197.45 269.45 166.1 256.95 136.95M175.4 121.55Q178.05 124.15 178.25 127.55 178.55 131.05 176.25 133.45 174 135.8 170.45 135.6 167.05 135.4 164.4 132.8 161.75 130.25 161.5 126.8 161.25 123.3 163.55 121 165.85 118.7 169.3 118.8 172.75 118.95 175.4 121.55M175.45 160.3Q193.8 142.9 206.5 134.3 217.65 149.05 215.3 163 213 176.95 202.3 189.15 191.5 201.35 174.55 204.85 157.65 208.35 143.15 197 157.1 177.85 175.45 160.3M141.9 163.35Q142.2 166.85 139.85 169.15 137.6 171.55 134.1 171.3 130.7 171.2 128 168.6 125.4 166.05 125.1 162.55 124.85 159.1 127.15 156.75 129.45 154.45 132.9 154.6 136.4 154.7 139 157.3 141.65 159.9 141.9 163.35Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M139.85 169.15Q142.2 166.85 141.9 163.35 141.65 159.9 139 157.3 136.4 154.7 132.9 154.6 129.45 154.45 127.15 156.75 124.85 159.1 125.1 162.55 125.4 166.05 128 168.6 130.7 171.2 134.1 171.3 137.6 171.55 139.85 169.15M206.5 134.3Q193.8 142.9 175.45 160.3 157.1 177.85 143.15 197 157.65 208.35 174.55 204.85 191.5 201.35 202.3 189.15 213 176.95 215.3 163 217.65 149.05 206.5 134.3M178.25 127.55Q178.05 124.15 175.4 121.55 172.75 118.95 169.3 118.8 165.85 118.7 163.55 121 161.25 123.3 161.5 126.8 161.75 130.25 164.4 132.8 167.05 135.4 170.45 135.6 174 135.8 176.25 133.45 178.55 131.05 178.25 127.55Z"
          />
        </G>
        <G id="LoginStartSignup-Layer6_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M258.35 139.95Q255.05 131.5 250.3 124.65 246.35 118.95 241.45 114.35 230.85 104.35 215.6 98.95 183.65 88.55 150.25 102.95 115.8 116 99.85 145.7 92.85 160.45 92.55 174.8 92.25 188.65 98.2 204.75 103.4 218.7 112.55 228.7 122.85 240 138.15 246.25 139.05 246.55 139.9 246.95 172.6 257.05 208.05 242.8 240.5 229.8 255.1 200.4 269.7 169.6 258.35 139.95M177.35 122.35Q179.9 125 180.05 128.4 180.3 131.9 177.9 134.2 175.65 136.5 172.15 136.25 168.7 136 166.1 133.4 163.5 130.75 163.3 127.3 163.15 123.8 165.5 121.55 167.85 119.25 171.3 119.45 174.7 119.7 177.35 122.35M215.05 164.3Q212.55 177.9 201.75 189.6 190.95 201.3 174.25 204.4 157.65 207.45 143.65 196 157.7 177.55 176.1 160.8 194.4 144.1 207 136 217.65 150.6 215.05 164.3M140.2 156.8Q142.75 159.45 142.9 162.9 143.15 166.4 140.75 168.7 138.5 171 135 170.75 131.55 170.5 128.95 167.8 126.4 165.25 126.2 161.75 126.05 158.25 128.35 156 130.7 153.75 134.15 153.95 137.6 154.15 140.2 156.8Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M142.9 162.9Q142.75 159.45 140.2 156.8 137.6 154.15 134.15 153.95 130.7 153.75 128.35 156 126.05 158.25 126.2 161.75 126.4 165.25 128.95 167.8 131.55 170.5 135 170.75 138.5 171 140.75 168.7 143.15 166.4 142.9 162.9M201.75 189.6Q212.55 177.9 215.05 164.3 217.65 150.6 207 136 194.4 144.1 176.1 160.8 157.7 177.55 143.65 196 157.65 207.45 174.25 204.4 190.95 201.3 201.75 189.6M180.05 128.4Q179.9 125 177.35 122.35 174.7 119.7 171.3 119.45 167.85 119.25 165.5 121.55 163.15 123.8 163.3 127.3 163.5 130.75 166.1 133.4 168.7 136 172.15 136.25 175.65 136.5 177.9 134.2 180.3 131.9 180.05 128.4Z"
          />
        </G>
        <G id="LoginStartSignup-Layer5_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M243.8 134.6Q250.8 134.55 255.15 133.2 254.65 132.35 254.15 131.5 252.3 128.5 250.15 125.75 241.2 114.3 226.9 106.7 197 91.5 161.75 100.65 125.7 108.35 105.4 135.3 96.25 148.7 93.8 162.95 91.4 176.55 94.85 193.35 99.2 214.4 112.9 228.55 119.4 235.3 128.05 240.45 128.9 240.9 129.65 241.4 160.45 256.4 197.7 247.65 231.7 239.8 250.55 212.9 269.65 184.65 263 153.65 260.45 142.35 255.15 133.2 250.8 134.55 243.8 134.6M177.7 121.45Q181.1 121.8 183.6 124.55 186.1 127.25 186.1 130.7 186.25 134.2 183.75 136.4 181.4 138.65 177.85 138.2 174.5 137.85 171.95 135.15 169.5 132.45 169.45 128.95 169.35 125.5 171.8 123.3 174.2 121.1 177.7 121.45M177.4 165.65Q195.05 151.8 206.95 145.35 215.5 159.5 212.25 171.75 209 184 198.5 193.85 187.95 203.7 172.75 205.2 157.6 206.75 145.85 195.25 159.75 179.5 177.4 165.65M143.35 168.25Q140.95 170.45 137.45 170.1 134.1 169.75 131.55 166.95 129.05 164.25 129.05 160.8 129 157.3 131.4 155.1 133.85 152.95 137.25 153.25 140.75 153.6 143.2 156.35 145.7 159.1 145.75 162.55 145.85 166.05 143.35 168.25Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M137.45 170.1Q140.95 170.45 143.35 168.25 145.85 166.05 145.75 162.55 145.7 159.1 143.2 156.35 140.75 153.6 137.25 153.25 133.85 152.95 131.4 155.1 129 157.3 129.05 160.8 129.05 164.25 131.55 166.95 134.1 169.75 137.45 170.1M206.95 145.35Q195.05 151.8 177.4 165.65 159.75 179.5 145.85 195.25 157.6 206.75 172.75 205.2 187.95 203.7 198.5 193.85 209 184 212.25 171.75 215.5 159.5 206.95 145.35M183.6 124.55Q181.1 121.8 177.7 121.45 174.2 121.1 171.8 123.3 169.35 125.5 169.45 128.95 169.5 132.45 171.95 135.15 174.5 137.85 177.85 138.2 181.4 138.65 183.75 136.4 186.25 134.2 186.1 130.7 186.1 127.25 183.6 124.55Z"
          />
        </G>
        <G id="LoginStartSignup-Layer4_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M207.1 158Q218.15 166.1 224.5 166.65 229.9 167.15 235.2 161.05 238.75 156.95 239.85 155.85 242.8 153.15 246.15 151.95 251.7 149.95 259.95 151.85 254.3 134.55 239.2 121.35 213.7 99.9 177.7 100.85 141.2 100.05 115.55 121.45 103.65 132.4 98.05 145.55 92.65 158.15 92.15 175.05 91.35 206 112.7 227.2 113.8 226.1 115 225 113.8 226.1 112.7 227.2 113.8 228.25 114.9 229.3 141.15 250.75 179.05 250.75 213.65 250.85 237.95 229.15 262.75 206.25 263.35 174.8 263.45 162.55 259.95 151.85 251.7 149.95 246.15 151.95 242.8 153.15 239.85 155.85 238.75 156.95 235.2 161.05 229.9 167.15 224.5 166.65 218.15 166.1 207.1 158M185.95 144.05Q187.75 141.1 191 140.5 194.1 139.95 196.9 142.05 199.6 144.15 200.3 147.8 201 151.45 199.2 154.4 197.4 157.4 194.2 158 190.95 158.6 188.2 156.4 185.55 154.4 184.8 150.65 184.15 147.1 185.95 144.05M175.5 180.9Q193.6 178.15 204.6 178.3 205.15 191.65 197.95 198.95 190.85 206.3 179.4 209.05 168 211.8 156.5 206.9 145 202 141.1 189.3 157.3 183.7 175.5 180.9M135.1 152.15Q136.95 149.15 140.15 148.6 143.3 148 146.05 150.1 148.8 152.25 149.5 155.9 150.15 159.45 148.4 162.45 146.65 165.5 143.3 166.05 140.15 166.7 137.45 164.45 134.65 162.45 134.05 158.7 133.3 155.1 135.1 152.15Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M140.15 148.6Q136.95 149.15 135.1 152.15 133.3 155.1 134.05 158.7 134.65 162.45 137.45 164.45 140.15 166.7 143.3 166.05 146.65 165.5 148.4 162.45 150.15 159.45 149.5 155.9 148.8 152.25 146.05 150.1 143.3 148 140.15 148.6M204.6 178.3Q193.6 178.15 175.5 180.9 157.3 183.7 141.1 189.3 145 202 156.5 206.9 168 211.8 179.4 209.05 190.85 206.3 197.95 198.95 205.15 191.65 204.6 178.3M191 140.5Q187.75 141.1 185.95 144.05 184.15 147.1 184.8 150.65 185.55 154.4 188.2 156.4 190.95 158.6 194.2 158 197.4 157.4 199.2 154.4 201 151.45 200.3 147.8 199.6 144.15 196.9 142.05 194.1 139.95 191 140.5Z"
          />
        </G>
        <G id="LoginStartSignup-Layer3_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M236.15 124.05Q211.95 103.65 177.7 104.55 143 103.8 118.6 124.15 107.3 134.55 101.95 147.05 96.85 159.05 96.35 175.1 95.6 203.25 114.2 222.9 116 224.8 118 226.65 124.5 232 131.8 235.95 152.35 247.05 178.95 247.05 211.9 247.15 234.95 226.5 258.55 204.75 259.1 174.85 259.4 144.4 236.15 124.05M107.2 147.8Q109.5 145.15 112.75 145.2 115.95 145.15 118.3 147.75 120.6 150.3 120.65 154.05 120.7 157.65 118.4 160.3 116.15 163 112.75 162.95 109.55 163 107.3 160.3 104.9 157.85 104.95 154.05 104.85 150.35 107.2 147.8M136.75 184.2Q149.9 186.05 157.45 188.65 154.5 199.15 147.7 203.3 140.95 207.4 132.35 207 123.8 206.65 117.1 200.25 110.45 193.8 110.95 183.05 123.55 182.25 136.75 184.2M158.6 156.05Q158.65 159.8 156.35 162.4 154.05 165 150.8 165.05 147.5 165.05 145.2 162.4 142.95 159.95 142.85 156.1 142.85 152.55 145.15 149.85 147.45 147.3 150.75 147.25 153.9 147.25 156.3 149.8 158.55 152.4 158.6 156.05Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M156.35 162.4Q158.65 159.8 158.6 156.05 158.55 152.4 156.3 149.8 153.9 147.25 150.75 147.25 147.45 147.3 145.15 149.85 142.85 152.55 142.85 156.1 142.95 159.95 145.2 162.4 147.5 165.05 150.8 165.05 154.05 165 156.35 162.4M157.45 188.65Q149.9 186.05 136.75 184.2 123.55 182.25 110.95 183.05 110.45 193.8 117.1 200.25 123.8 206.65 132.35 207 140.95 207.4 147.7 203.3 154.5 199.15 157.45 188.65M112.75 145.2Q109.5 145.15 107.2 147.8 104.85 150.35 104.95 154.05 104.9 157.85 107.3 160.3 109.55 163 112.75 162.95 116.15 163 118.4 160.3 120.7 157.65 120.65 154.05 120.6 150.3 118.3 147.75 115.95 145.15 112.75 145.2Z"
          />
        </G>
        <G id="LoginStartSignup-Layer2_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M115.45 176.35Q115 176.35 114.55 176.4 114.45 187.4 118.25 196.7 120.15 195.95 121.65 194.1 124.25 191.1 124.25 186.75 124.25 182.45 121.65 179.4 119.1 176.35 115.45 176.35M121.45 149.15Q119.15 151.85 119.15 155.4 119.25 159.25 121.5 161.7 123.8 164.35 127.1 164.35 130.35 164.3 132.65 161.7 134.95 159.1 134.9 155.35 134.85 151.7 132.6 149.1 130.2 146.55 127.05 146.55 123.75 146.6 121.45 149.15Z"
          />
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M223.1 135.6Q204.3 119.75 177.75 120.45 150.8 119.85 131.85 135.65 123.85 143 119.75 151.65 119.3 152.55 118.9 153.45 118.05 155.55 117.3 157.8 114.85 165.55 114.55 175.25 114.55 175.85 114.55 176.4 115 176.35 115.45 176.35 119.1 176.35 121.65 179.4 124.25 182.45 124.25 186.75 124.25 191.1 121.65 194.1 120.15 195.95 118.25 196.7 122.4 207.05 131.35 215.3 150.75 231.15 178.7 231.15 204.3 231.2 222.2 215.2 240.55 198.3 240.95 175.05 241.2 151.4 223.1 135.6M119.15 155.4Q119.15 151.85 121.45 149.15 123.75 146.6 127.05 146.55 130.2 146.55 132.6 149.1 134.85 151.7 134.9 155.35 134.95 159.1 132.65 161.7 130.35 164.3 127.1 164.35 123.8 164.35 121.5 161.7 119.25 159.25 119.15 155.4Z"
          />
        </G>
        <G id="LoginStartSignup-Layer1_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M223.1 175.25Q223.25 158.3 210.3 147 196.8 135.6 177.75 136.1 158.4 135.7 144.85 147.05 138.55 152.85 135.6 159.8 132.7 166.45 132.45 175.4 132.45 175.8 132.45 176.25 132.4 184.1 135.1 190.8 138.05 198.2 144.5 204.1 158.4 215.45 178.45 215.45 196.8 215.5 209.65 204.05 222.75 191.9 223.1 175.25Z"
          />
        </G>
        <Path
          id="LoginStartSignup-Layer23_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M142.05 179.05Q160.6 175.25 180.9 174.8 201.15 174.4 213.25 176.2 211.9 190.95 202.95 197.9 194.1 204.95 181.15 206.3 168.25 207.7 156.3 200.6 144.45 193.6 142.05 179.05Z"
        />
        <Path
          id="LoginStartSignup-Layer23_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M241.05 227.25Q248.4 232.65 252.8 239.1 256.8 244.9 257.9 250.6 259.35 258.45 246.8 259.5 239.8 260.05 225.2 259.2M112.8 228.4Q106.45 233.35 102.5 239.1 98.5 244.9 97.4 250.6 95.95 258.45 108.5 259.5 115.5 260.05 130.1 259.2"
        />
        <Path
          id="LoginStartSignup-Layer22_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M142.15 180.8Q160.3 175.4 180.5 173.25 200.65 171.1 212.85 171.8 212.8 186.6 204.55 194.35 196.25 202.1 183.55 204.6 170.75 207.05 158.3 201.05 145.85 195.1 142.15 180.8Z"
        />
        <Path
          id="LoginStartSignup-Layer22_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M244.55 222.65Q251.7 226.95 256.45 232.35 261.1 237.65 262.85 243.15 265.2 250.8 252.85 253.3 246 254.7 231.4 255.55M112.95 228.55Q106.05 234 101.8 240.05 97.85 245.6 96.9 250.65 95.45 258.6 108.15 260.3 112.4 260.85 119.45 260.85 123.25 260.8 129.85 260.75M242.7 221.6Q243.65 222.1 244.55 222.65"
        />
        <Path
          id="LoginStartSignup-Layer21_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.75 191.9Q159.6 178.05 178.9 166.65 198.2 155.2 210.85 150.35 217.45 165.55 212.65 177.25 207.8 189 196.15 197.35 184.4 205.75 169.1 205.25 153.9 204.85 143.75 191.9Z"
        />
        <Path
          id="LoginStartSignup-Layer21_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M264.7 171.6Q279.65 169.4 283.15 164.45 287.75 158.1 275.8 142.7M256.95 172.45Q261.15 172.1 264.7 171.6M112.9 228.5Q105.65 234.2 101 240.1 96.25 246.1 95.35 250.85 93.85 258.95 106.1 261.85 112.7 263.45 127.3 263.7"
        />
        <Path
          id="LoginStartSignup-Layer20_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.6 196Q157.65 177.55 176.05 160.8 194.35 144.1 206.95 136 217.6 150.6 215 164.3 212.5 177.9 201.7 189.6 190.9 201.3 174.2 204.4 157.6 207.45 143.6 196Z"
        />
        <Path
          id="LoginStartSignup-Layer20_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M253.95 130.65Q267.6 124.05 271.45 114.6 276.1 103.55 269.85 80.75M112.5 228.7L110.05 230.25Q103.05 235.05 98.75 241 95.15 245.95 93.75 251.3 91.65 259.25 103.2 263 109.4 265 123.8 266.3M250.25 132.3Q252.2 131.5 253.95 130.65"
        />
        <Path
          id="LoginStartSignup-Layer19_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M246 119Q261.15 108.8 263.3 97.45 265.65 85.7 255 64.6M111.7 228.7Q110.5 229.45 109.35 230.2 102.8 234.65 98.45 240.1 94.05 245.6 92.55 251.25 89.1 264.5 122.35 267.5"
        />
        <Path
          id="LoginStartSignup-Layer19_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.15 196.9Q157.1 177.75 175.45 160.2 193.8 142.8 206.5 134.2 217.65 148.95 215.3 162.9 213 176.85 202.3 189.05 191.5 201.25 174.55 204.75 157.65 208.25 143.15 196.9Z"
        />
        <Path
          id="LoginStartSignup-Layer18_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M244.35 117.15Q258.8 105 259.65 94 260.75 80.35 241.35 66.95M111.7 228.75Q110.5 229.5 109.35 230.25 102.8 234.7 98.45 240.15 94.05 245.65 92.55 251.3 89.1 264.55 122.35 267.55"
        />
        <Path
          id="LoginStartSignup-Layer18_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.15 196.95Q157.1 177.8 175.45 160.25 193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95Z"
        />
        <Path
          id="LoginStartSignup-Layer17_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M242.95 115.65Q257.7 98.55 247.35 84.75 243.55 79.7 235.55 74.05 226.85 68.35 223.85 65.95M111.7 228.75Q110.5 229.5 109.35 230.25 102.8 234.7 98.45 240.15 94.05 245.65 92.55 251.3 89.1 264.55 122.35 267.55"
        />
        <Path
          id="LoginStartSignup-Layer17_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.15 196.95Q157.1 177.8 175.45 160.25 193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95Z"
        />
        <Path
          id="LoginStartSignup-Layer16_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M243.65 116.4Q252 106.9 253.35 100.25 254.55 94.3 250.15 88.2 243.8 81 240.5 76.5 234.6 68.35 233.35 58.95M111.7 228.75Q110.5 229.5 109.35 230.25 102.8 234.7 98.45 240.15 94.05 245.65 92.55 251.3 89.1 264.55 122.35 267.55"
        />
        <Path
          id="LoginStartSignup-Layer16_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.15 196.95Q157.1 177.8 175.45 160.25 193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95Z"
        />
        <Path
          id="LoginStartSignup-Layer15_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M245.25 118.1Q253.4 111.8 255.05 106.55 256.45 102 253 95 248.15 85.3 247.3 81.35 245.35 71.95 250.15 60.85M111.7 228.7Q110.5 229.45 109.35 230.2 102.8 234.65 98.45 240.1 94.05 245.6 92.55 251.25 89.1 264.5 122.35 267.5"
        />
        <Path
          id="LoginStartSignup-Layer15_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.15 196.9Q157.1 177.75 175.45 160.2 193.8 142.8 206.5 134.2 217.65 148.95 215.3 162.9 213 176.85 202.3 189.05 191.5 201.25 174.55 204.75 157.65 208.25 143.15 196.9Z"
        />
        <Path
          id="LoginStartSignup-Layer14_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M247.85 121.3Q255.55 117.15 258.25 113.2 261.4 108.7 258.65 101.05 256.9 96 256.55 94.45 255.6 90.6 256.25 87.1 257.8 77.95 270.95 67.75M111.7 228.75Q110.5 229.5 109.35 230.25 102.8 234.7 98.45 240.15 94.05 245.65 92.55 251.3 89.1 264.55 122.35 267.55"
        />
        <Path
          id="LoginStartSignup-Layer14_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.15 196.95Q157.1 177.8 175.45 160.25 193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95Z"
        />
        <Path
          id="LoginStartSignup-Layer13_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M249.95 124.25Q257.05 120.8 260.8 116.7 264.8 112.35 266.35 104.95 268.9 92.7 269.3 91.65 272.1 83.4 279.35 76.5M111.65 228.75Q110.45 229.5 109.3 230.25 102.75 234.7 98.4 240.15 94 245.65 92.5 251.3 89.05 264.55 122.3 267.55"
        />
        <Path
          id="LoginStartSignup-Layer13_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.1 196.95Q157.05 177.8 175.4 160.25 193.75 142.85 206.45 134.25 217.6 149 215.25 162.95 212.95 176.9 202.25 189.1 191.45 201.3 174.5 204.8 157.6 208.3 143.1 196.95Z"
        />
        <Path
          id="LoginStartSignup-Layer12_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M248.35 121.95Q264.35 113.35 267.65 102.25 271.1 90.8 262.6 68.75M111.7 228.75Q110.5 229.5 109.35 230.25 102.8 234.7 98.45 240.15 94.05 245.65 92.55 251.3 89.1 264.55 122.35 267.55"
        />
        <Path
          id="LoginStartSignup-Layer12_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.15 196.95Q157.1 177.8 175.45 160.25 193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95Z"
        />
        <Path
          id="LoginStartSignup-Layer11_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M244.35 117.15Q258.8 105 259.65 94 260.75 80.35 241.35 66.95M111.7 228.75Q110.5 229.5 109.35 230.25 102.8 234.7 98.45 240.15 94.05 245.65 92.55 251.3 89.1 264.55 122.35 267.55"
        />
        <Path
          id="LoginStartSignup-Layer11_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.15 196.95Q157.1 177.8 175.45 160.25 193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95Z"
        />
        <Path
          id="LoginStartSignup-Layer10_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M242.95 115.65Q257.7 98.55 247.35 84.75 243.55 79.7 235.55 74.05 226.85 68.35 223.85 65.95M111.7 228.75Q110.5 229.5 109.35 230.25 102.8 234.7 98.45 240.15 94.05 245.65 92.55 251.3 89.1 264.55 122.35 267.55"
        />
        <Path
          id="LoginStartSignup-Layer10_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.15 196.95Q157.1 177.8 175.45 160.25 193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95Z"
        />
        <Path
          id="LoginStartSignup-Layer9_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M243.65 116.4Q252 106.9 253.35 100.25 254.55 94.3 250.15 88.2 243.8 81 240.5 76.5 234.6 68.35 233.35 58.95M111.7 228.75Q110.5 229.5 109.35 230.25 102.8 234.7 98.45 240.15 94.05 245.65 92.55 251.3 89.1 264.55 122.35 267.55"
        />
        <Path
          id="LoginStartSignup-Layer9_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.15 196.95Q157.1 177.8 175.45 160.25 193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95Z"
        />
        <Path
          id="LoginStartSignup-Layer8_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M245.25 118.15Q253.4 111.85 255.05 106.6 256.45 102.05 253 95.05 248.15 85.35 247.3 81.4 245.35 72 250.15 60.9M111.7 228.75Q110.5 229.5 109.35 230.25 102.8 234.7 98.45 240.15 94.05 245.65 92.55 251.3 89.1 264.55 122.35 267.55"
        />
        <Path
          id="LoginStartSignup-Layer8_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.15 196.95Q157.1 177.8 175.45 160.25 193.8 142.85 206.5 134.25 217.65 149 215.3 162.95 213 176.9 202.3 189.1 191.5 201.3 174.55 204.8 157.65 208.3 143.15 196.95Z"
        />
        <Path
          id="LoginStartSignup-Layer7_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M247.85 121.35Q255.55 117.2 258.25 113.25 261.4 108.75 258.65 101.1 256.9 96.05 256.55 94.5 255.6 90.65 256.25 87.15 257.8 78 270.95 67.8M111.7 228.8Q110.5 229.55 109.35 230.3 102.8 234.75 98.45 240.2 94.05 245.7 92.55 251.35 89.1 264.6 122.35 267.6"
        />
        <Path
          id="LoginStartSignup-Layer7_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.15 197Q157.1 177.85 175.45 160.3 193.8 142.9 206.5 134.3 217.65 149.05 215.3 163 213 176.95 202.3 189.15 191.5 201.35 174.55 204.85 157.65 208.35 143.15 197Z"
        />
        <Path
          id="LoginStartSignup-Layer6_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M143.65 196Q157.7 177.55 176.1 160.8 194.4 144.1 207 136 217.65 150.6 215.05 164.3 212.55 177.9 201.75 189.6 190.95 201.3 174.25 204.4 157.65 207.45 143.65 196Z"
        />
        <Path
          id="LoginStartSignup-Layer6_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M250.3 124.65Q259.8 120.95 262.55 116.45 264.75 112.85 263.1 105.15 261.35 97.05 263.5 92.65 267.05 85.2 281.85 78.6M112.55 228.7L110.1 230.25Q103.1 235.05 98.8 241 95.2 245.95 93.8 251.3 91.7 259.25 103.25 263 109.45 265 123.85 266.3"
        />
        <Path
          id="LoginStartSignup-Layer5_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M145.85 195.25Q159.75 179.5 177.4 165.65 195.05 151.8 206.95 145.35 215.5 159.5 212.25 171.75 209 184 198.5 193.85 187.95 203.7 172.75 205.2 157.6 206.75 145.85 195.25Z"
        />
        <Path
          id="LoginStartSignup-Layer5_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M243.8 134.6Q250.8 134.55 255.15 133.2 258 132.3 259.7 130.9 263.05 128.25 264 120.4 265.05 112.15 268.6 108.8 274.45 102.9 290.55 101.65M112.9 228.55Q105.65 234.25 101 240.15 96.25 246.15 95.35 250.9 93.85 259 106.1 261.9 112.7 263.5 127.3 263.75"
        />
        <Path
          id="LoginStartSignup-Layer4_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M141.1 189.3Q157.3 183.7 175.5 180.9 193.6 178.15 204.6 178.3 205.15 191.65 197.95 198.95 190.85 206.3 179.4 209.05 168 211.8 156.5 206.9 145 202 141.1 189.3Z"
        />
        <Path
          id="LoginStartSignup-Layer4_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M207.1 158Q218.15 166.1 224.5 166.65 229.9 167.15 235.2 161.05 238.75 156.95 239.85 155.85 242.8 153.15 246.15 151.95 251.7 149.95 259.95 151.85M115 225Q113.8 226.1 112.7 227.2M259.95 151.85Q264.65 152.9 270.2 155.25M112.7 227.2Q101.7 238.2 100.8 247.4 100.05 255.35 112.8 255.3 119.85 255.25 134.35 253.15"
        />
        <Path
          id="LoginStartSignup-Layer3_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M110.95 183.05Q123.55 182.25 136.75 184.2 149.9 186.05 157.45 188.65 154.5 199.15 147.7 203.3 140.95 207.4 132.35 207 123.8 206.65 117.1 200.25 110.45 193.8 110.95 183.05Z"
        />
        <Path
          id="LoginStartSignup-Layer3_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M131.8 235.95Q127.7 236.3 124.8 236.3 112.05 236.35 112.8 228.4 113.05 225.7 114.2 222.9"
        />
      </Defs>
      <G id="LoginStartSignup-Scene-1" overflow="visible">
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer23_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer23_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer23_0_2_STROKES" />
          </G>
          <animate attributeName="display" repeatCount="1" fill="freeze" dur="1.05" keyTimes="0;.977;1" values="none;inline;inline" />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer22_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer22_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer22_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.93;.977;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer21_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer21_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer21_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.884;.93;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer20_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer20_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer20_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.837;.884;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer19_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer19_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer19_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.791;.837;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer18_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer18_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer18_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.744;.791;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer17_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer17_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer17_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.698;.744;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer16_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer16_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer16_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.651;.698;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer15_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer15_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer15_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.605;.651;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer14_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer14_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer14_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.558;.605;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer13_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer13_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer13_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.512;.558;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer12_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer12_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer12_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.465;.512;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer11_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer11_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer11_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.419;.465;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer10_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer10_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer10_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.372;.419;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer9_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer9_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer9_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.326;.372;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer8_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer8_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer8_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.279;.326;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer7_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer7_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer7_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.233;.279;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer6_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer6_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer6_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.186;.233;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer5_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer5_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer5_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.14;.186;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer4_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer4_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer4_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.093;.14;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer3_0_FILL" />
            <Use xlinkHref="#LoginStartSignup-Layer3_0_1_STROKES" />
            <Use xlinkHref="#LoginStartSignup-Layer3_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.047;.093;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer2_0_FILL" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05"
            keyTimes="0;.023;.047;1"
            values="none;inline;none;none"
          />
        </G>
        <G>
          <G>
            <Use xlinkHref="#LoginStartSignup-Layer1_0_FILL" />
          </G>
          <animate attributeName="display" repeatCount="1" fill="freeze" dur="1.05" keyTimes="0;.023;1" values="inline;none;none" />
        </G>
      </G>
    </Svg>
  )
}
